/**
 * @file 函数去抖与函数节流
 */

/**
 * 函数去抖
 *
 * @param {Function} fn 执行函数
 * @param {number} t 时延
 * @return {Function}
 */
exports.debounce = (fn, t) => {
    let delay = t || 500;
    let timer;
    return function () {
        let args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            timer = null;
            fn.apply(this, args);
        }, delay);
    };
};

/**
 * 函数节流
 *
 * @param {Function} fn 执行函数
 * @param {number} t 时延
 * @return {Function}
 */
exports.throttle = (fn, t) => {
    let timer = null;
    let interval = t || 500;
    return function () {
        let context = this;
        let args = arguments;
        if (!timer) {
            fn.apply(context, args);
            timer = setTimeout(() => {
                timer = null;
            }, interval);
        }
    };
};
